<template>
  <v-text-field
    dense
    outlined
    persistent-placeholder
    :id="name"
    :label="label"
    :name="name"
    v-model="model"
  >
  </v-text-field>
</template>

<script>
export default {
  name: 'BaseTextInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: ['input'],
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
